import { lato, nunito_sans } from '@styles/fonts'
import { makeStyles } from 'tss-react/mui'

const useStyles = makeStyles()((theme) => ({
  rootContainer: {
    background: 'black',
    color: 'white',
    padding: theme.spacing(8.5, 7, 6),
    borderRadius: '40px',
  },
  zenRootContainer: {
    background: 'none',
    border: '1px solid black',
  },
  imgContainer: {
    position: 'relative',
    maxWidth: '100%',
    height: 'auto',
    marginBottom: theme.spacing(4),
    borderRadius: '16px',
    [theme.breakpoints.down('sm')]: {
      height: '123px',
      marginBottom: theme.spacing(0),
    },
    img: {
      width: '116px',
      height: '116px',
      [theme.breakpoints.down('sm')]: {
        width: '96px',
        height: '96px',
      },
    },
  },
  heading: {
    fontFamily: nunito_sans.style.fontFamily,
    fontSize: '32px',
    lineHeight: '43.65px',
    fontWeight: 800,
    color: 'rgba(255,255,255,1)',
    marginBottom: theme.spacing(3.5),
    textTransform: 'uppercase',
    [theme.breakpoints.down('md')]: {
      fontSize: '24px',
      lineHeight: '32.74px',
      marginBottom: theme.spacing(4),
    },
  },
  text: {
    fontFamily: lato.style.fontFamily,
    fontWeight: 400,
    fontSize: '20px',
    lineHeight: '26px',
    opacity: 0.7,
    marginBottom: theme.spacing(10),
    [theme.breakpoints.down('md')]: {
      fontSize: '14px',
      lineHeight: '16.8px',
      marginBottom: theme.spacing(5),
    },
  },
  btn: {
    background: 'white',
    color: 'black',
    textAlign: 'center',
    '&:hover': {
      background: 'white',
      color: 'black',
    },
    width: '100%',

    [theme.breakpoints.down('sm')]: {
      flex: 1,
    },
  },
  zenColor: {
    color: '#1c1c1c',
  },
}))

export default useStyles
